<template>
  <div class="max-w-5xl mx-auto">

    <div class="md:px-4">

      <h2 class="mb-6 text-xl leading-tight font-bold">Aitäh, et oled meiega kannatlik olnud!</h2>

      <p class="mb-6 md:text-lg"><span class="font-bold">Sinu panus aitab meil Eesti projekteerimise turgu paremuse poole muuta,</span> võimaldades projekteerijatel saada suuremat tasu ja tellijal kvaliteetsemaid projekti meeskondasid.</p>

      <p class="mb-6 md:text-lg">Alljärgnevalt on toodud list uuendusi, mis Iffenti viimasel ajal lisatud on.</p>

      <ul class="mb-6 md:text-lg mt-3 list-disc list-inside">
        <li>
          <span class="font-bold">ID kaardiga sisselogimine</span>
          <br>
          Eelneva M-ID ja Smart-ID võimalusele lisandus nüüd ka ID kaardi paroolidega sisselogimise võimalus. <span class="font-bold">Lisaks nendele saad sisselogimisel enda profiili alt määrata ka parooli, millega edaspidi platvormile ligi pääsed. Kasutajanimeks on alati sinu e-maili aadress, mida näed ja saad muuta samuti profiili alt.</span>
        </li>
        <br>
        <li>
          <span class="font-bold">Lisateenuste lisamise võimalus projekti</span>
          <br>
          Lisaks peamistele valdkondadele (arhitektuur ja inseneri osad) on Iffentis kokku 17 lisatööde valdkonda. Kõik lisateenused, mis on seotud hoone suurusega, on automaatselt hinnastatud ja need teenused, mis otseselt ei sõltu hoone mahust, nende hind lepitakse tellija ja töö tegija vahel peale esmast infovahetust. <span class="font-bold">Kui oled mõne spetsiifilisema ala spetsialist, siis märgi end peale sisselogimist profiili all vastava teenuse teostajaks, nii hakkad saama antud teenuse kutseid projektidesse.</span>
        </li>
      </ul>

      <p class="mb-6 md:text-lg">Oleme alati Teie jaoks olemas, kui peaksite platvormil navigeerimisega abi vajama ning teie ettepanekud on alati teretulnud!</p>

      <h2 class="mb-6 text-xl leading-tight font-bold">Iffenti meeskond!</h2>

      <p>
        <a class="text-blue-500" href="mailto: info@iffent.ee">info@iffent.ee</a>
      </p>

      <p>
        <a href="tel:+37256456651">+ 372 56456651</a>
      </p>
    </div>

    <div class="flex flex-col items-center mt-10">
      <button class="w-full text-white bg-blue-500 uppercase btn xs:w-72" @click="sendAction">
        OK
      </button>
    </div>
  </div>
</template>

<script>

import {updateSeenUpdates} from "@/store/user.api";
import store from "@/store";

export default {
  components: {
    //...
  },
  data() {
    return {
      //...
    }
  },
  computed: {
    //...
  },
  methods: {
    sendAction() {
      updateSeenUpdates().then(() => {
        store.dispatch('global/getUser');
      }, () => {
        this.showToast("Uuenduste nägemise kinnituse saatmine ebaõnnestus", "error")
      });
    }
  }
}
</script>
